<template>
  <div class="app-footer">
    <div class="footer-info">
      <div class="footer-nav-box" style="border-bottom: 1px solid #939395;">
        <div class="footer-info-content">
          <div class="footer-info-content-item" v-for="(item, index) in footerNavList.left" :key="index">
            <p class="main-title">{{item.name}}</p>
            <p class="sub-title" v-for="(child, subIndex) in item.children" :key="subIndex" @click="goDetail(child.path)">{{ child.name }}</p>
          </div>
        </div>
        <div class="footer-info-content">
          <div class="footer-info-content-item" v-for="(item, index) in footerNavList.right" :key="index">
            <p class="main-title">{{item.name}}</p>
            <p class="sub-title" v-for="(child, subIndex) in item.children" :key="subIndex" @click="goDetail(child.path)">{{ child.name }}</p>
          </div>
        </div>
      </div>
      <div class="my-info">
        <!-- <p class="phone-num">违法/不良信息举报电话：</p> -->
        <!-- <p class="phone-num">400 006 3390</p> -->
        <!-- <p class="work-time">（服务时间：周一到周五，每天9：30-18：30)</p> -->
        <div class="detail-box">
          <div class="detail-item">
            <p class="lable lable-spc">违法/不良信息举报邮箱</p>
            <p class="semi">：</p>
            <p class="des">scskszx@tal.com</p>
          </div>
          <div class="detail-item">
            <p class="lable"><span>邮</span><span>箱</span></p>
            <p class="semi">：</p>
            <p class="des">scs@tal.com</p>
          </div>
          <div class="detail-item">
            <p class="lable"><span>地</span><span>址</span></p>
            <p class="semi">：</p>
            <p class="des">北京市昌平区乐业路沙河万达A座</p>
          </div>
          <div class="detail-item">
            <p class="lable">收款信息</p>
            <p class="semi">：</p>
            <p class="des">收款账户 北京乐柏教育咨询有限公司<br>开户银行 招商银行北京首体科技金融支行<br>开户账号 110911363410001</p>
          </div>
        </div>
         <p class="copyright">Copyright © ️2020 好未来版权所有 北京彼芯托育服务有限公司</p>
         <p class="icp">京ICP备18011062号-1</p>
         <p class="icp">晋公网安备14102102000119号</p>
      </div>
    </div>
    <div class="footer-bottom">
      <!-- <div class="footer-item callcenter">
        <callCenter></callCenter>
      </div> -->
      <div class="footer-item service" @click="showService = true">
        <img class="item-icon" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/common/icon-doc.png">
        <p>合作咨询</p>
      </div>
    </div>
    <specialService v-if="showService" @close="showService = false"></specialService>
  </div>
</template>
<script>
import { footerNavList } from '../const/index'
import specialService from './components/special-service'
// import callCenter from '@/components/callcenter'
export default {
  data () {
    return {
      footerNavList: footerNavList,
      showService: false
    }
  },
  components: { specialService },
  methods: {
    goDetail (path) {
      console.log('ss', path)
      this.$router.push(path)
    },
    goBeian () {
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14102102000119')
    }    
  }
}
</script>
<style lang="scss" scoped>
.app-footer{
  .footer-info {
    background: #1B1D22;
    width: 100%;
    padding: 40px 50px 66px;
    font-family:PingFangSC-Regular,PingFang SC;
    .footer-nav-box{
      display: flex;
      justify-content: center;
      align-items: flex-start;
      padding-bottom: 30px;
      .footer-info-content{
        width: 50%;
        text-align: left;
        .footer-info-content-item{
          margin-bottom: 24px;
          .main-title{
            font-size:12px;
            font-weight:400;
            color: #ffffff;
            line-height: 26px;
          }
          .sub-title{
            font-size:12px;
            font-weight:400;
            color: #939395;
            line-height: 26px;
          }
          &:last-of-type{
            margin-bottom: 0px;
          }
        }
      }
    }
    .my-info{
      width: 100%;
      margin-top: 30px;
      text-align: left;
      .phone-num{
        font-size:18px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:25px;
      }
      .work-time, .copyright, .icp {
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(147,147,149,1);
        line-height:22px;
        margin-left: -7px;
      }
      .copyright {
        margin-top: 20px;
      }
      .detail-box{
        margin-top: 30px;
        text-align: left;
        .detail-item{
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          .lable{
            font-size: 12px;
            color: #ffffff;
            line-height: 22px;
            width: 54px;
            text-align: justify;
            &-spc{
              width: 140px;
            }
            &::after {
              display: inline-block;
              width: 100%;
              content: '';
              height: 0;
            }
          }
          .semi{
            font-size: 12px;
            color: #ffffff;
            line-height: 22px;
          }
          .des{
            flex: 1;
            font-size: 12px;
            color: #939395;
            line-height: 22px;
          }
        }
      }
    }
  }
  .footer-bottom{
    position: fixed;
    width: 100%;
    bottom: 0px;
    left: 0px;
    z-index: 998;
    display: flex;
    justify-content: center;
    align-items: center;
    .footer-item{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height:22px;
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(77,77,77,1);
      line-height:22px;
      height: 50px;
      .item-icon{
        width: 16px;
        height: 16px;
        margin-right: 9px;
      }
      &.callcenter{
        background: #ffffff;
      }
      &.service{
        background: #EE4E3F;
        color: #ffffff;
      }
    }
  }
}
</style>
